import { createContext, use } from "react";
import type { RangeOfOptionals } from "./useDates";

/** Date picker header context. */
export const DatePickerHeaderContext = createContext<RangeOfOptionals>([0, 0]);
DatePickerHeaderContext.displayName = "Date Picker Header";

/** Provide access to dates selected using the date picker header. */
export function useHeaderDates() {
    return use(DatePickerHeaderContext);
}
